import { render, staticRenderFns } from "./RenewIcon.vue?vue&type=template&id=4432a334&"
import script from "./RenewIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RenewIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports